module.exports = __webpack_public_path__ + "images/Card3cd2c2f3fe46fb7fc64db9e882a5b83d4.png";